// extracted by mini-css-extract-plugin
module.exports = {"Transition":"Transition_Transition__1xcVw","menuOpen":"Transition_menuOpen__1kXSF"};